import {
  type DocumentData,
  limit,
  orderBy,
  type QueryConstraint,
  startAfter,
  type Timestamp,
  where,
} from "firebase/firestore";
import { firestoreApi } from "../../core/apis/firestoreApi";
import BaseApi from "../../core/BaseApi";
import {
  type BusinessFeedCommentReplyData,
  BusinessFeedCommentReplyModel,
} from "./BusinessFeedCommentReplyModel";

export default class BusinessFeedCommentsReplyApi extends BaseApi<
  BusinessFeedCommentReplyModel,
  BusinessFeedCommentReplyData
> {
  /* PRIVATE APIS */

  async getFeedCommentReplyForCommentItem(
    commentUid: string,
    startFromTs?: Timestamp,
  ) {
    const qs: QueryConstraint[] = [
      where("feedCommentUid", "==", commentUid),
      orderBy("ts", "desc"),
      limit(5),
    ];

    if (startFromTs) {
      qs.push(startAfter(startFromTs)); // Fetch comments before this timestamp
    }

    const querySnapshots = await firestoreApi.queryDocuments(this.db, ...qs);

    const models: BusinessFeedCommentReplyModel[] = [];

    querySnapshots.forEach((querySnapshot) => {
      models.push(this.fromFirestore(querySnapshot));
    });

    this.store.load(models);
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_feed_comments_replies`;
  }

  get store() {
    return this.stores.businessFeedCommentsReplyStore;
  }

  fromFirestore(res: DocumentData): BusinessFeedCommentReplyModel {
    return new BusinessFeedCommentReplyModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
